/* eslint-disable import/no-mutable-exports */

import type { ThemeOptions } from '@mui/material';
import { createTheme } from '@mui/material';

import { colors } from './resources/colors';
import { fontSizes } from './resources/fontSizes';

const common = {
  typography: {
    htmlFontSize: 12,
    fontFamily: ['Roboto', "'Open Sans'", 'sans-serif'].join(','),
    fontSize: 12,
    fontWeightLight: 300,
    fontWeightRegular: 'normal',
    fontWeightBold: 'bold',
    h1: {
      fontSize: fontSizes.inch,
    },
    h2: {
      fontSize: fontSizes.nonpareil,
    },
    h3: {
      fontSize: fontSizes.canon,
    },
    h4: {
      fontSize: fontSizes.paragon,
    },
    h5: {
      fontSize: fontSizes.greatPrimer,
    },
    h6: {
      fontSize: fontSizes.primer,
    },
  },
  shape: {
    borderRadius: 4,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  components: {
    MuiTextField: {
      defaultProps: {
        InputLabelProps: {
          shrink: true,
        },
        helperText: ' ',
      },
    },
    MuiBreadcrumbs: {
      defaultProps: {
        separator: '>',
      },
    },
  },
  common: {
    colors,
    fontSizes,
  },
} as Partial<ThemeOptions>;

const lightTheme = createTheme({
  ...common,
  palette: {
    mode: 'light',
    primary: {
      main: colors.cobaltBlue,
      dark: colors.mermaidBlue,
    },
    secondary: {
      main: colors.harborBlue,
      dark: colors.harborBlue,
    },
    background: {
      default: colors.white,
      paper: colors.white,
      // @ts-expect-error custom contrast text color
      contrastText: colors.black,
      emailBody: colors.emailBodyBackground,
    },
    error: {
      main: colors.mammaryRed,
    },
    warning: {
      main: colors.terraCotta,
    },
    info: {
      main: colors.deepSkyBlue,
    },
    success: {
      main: colors.forestGreen,
    },
    border: {
      soft: colors.softBlack,
    },
  },
});

const darkTheme = createTheme({
  ...common,
  palette: {
    mode: 'dark',
    primary: {
      main: colors.stormyBlue,
      dark: colors.stormyBlue,
    },
    secondary: {
      main: colors.arcticBlue,
    },
    background: {
      default: colors.darkSlateBlue,
      paper: colors.darkSlateBlue,
      // @ts-expect-error custom contrast text color
      contrastText: colors.white,
      emailBody: colors.darkNavyBlue,
    },
    error: {
      main: colors.blush,
    },
    warning: {
      main: colors.copper,
    },
    success: {
      main: colors.mintGreen,
    },
    info: {
      main: colors.skyBlue,
    },
    border: {
      soft: colors.softWhite,
    },
  },
});

export { lightTheme, darkTheme };
